export default __webpack_public_path__ + "static/media/bfloral.8fa77f7e.jpg";